import { createReducer } from 'typesafe-actions'
import { ActionTypes } from '../types'
import { canUpdateUserData } from '../actions'

export type UsersState = {
  canUpdate: boolean
}

export const initialState = {
  canUpdate: false,
}

export const users = createReducer<UsersState, ActionTypes>(initialState).handleAction(
  canUpdateUserData,
  (state, { payload }) => ({ ...state, canUpdate: payload }),
)
